/**
 * Компайл-тайм-сторож и рантайм-фолбэк одним вызовом.
 *
 * `never` в первом параметре ломает СБОРКУ, если разбор перестал быть полным
 * (появился новый тип блока или новый вариант вердикта) — ровно то, ради чего
 * заводят `default`-ветку с присваиванием в `never`.
 *
 * Но одного сторожа мало: блоки едут с БЭКА, и тип, которого фронт ещё не
 * знает, доезжает до этих же `switch` в рантайме. Обычный идиом
 * (`const x: never = value; return x`) возвращает в этом случае сам объект —
 * `initialAnswer` отдавал `undefined`, а `isAnswered` бросал и ронял весь
 * диалог предпросмотра. Поэтому значение возвращается ЯВНО заданное.
 */
export const exhaustive = <T>(_unhandled: never, fallback: T): T => fallback
